import {
    Dialog,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableContainer,
    Paper,
} from '@material-ui/core';
import { TableBody } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { SubmitButton } from '../../../../lib/Button';
import { getAllowedBankDetails } from '../../../../redux-store/actions/newPurchase';

const useStyles = makeStyles((theme) => ({
    mobileTable: {
        display: 'none',
        '@media (max-width: 768px)': {
            display: 'block',
            margin: '0 auto',
            '& th, & td': {
                border: '1px solid #ddd',
                padding: '12px 8px',
                textAlign: 'left',
                fontSize: '14px',
            },
        },
    },
    heading: {
        '@media (max-width: 768px)': {
            '& h3': {
                '& span': {
                    fontSize: '14px',
                    float: 'right',
                    fontWeight: 600,
                    color: '#333',
                    marginTop: '-18px',
                    '& img': {
                        width: '10px',
                        height: '10px',
                    },
                },
            },
        },
        '& span': {
            fontSize: '14px',
            float: 'right',
            fontWeight: 600,
            color: '#333',
        },
        marginBottom: '10px',
    },
    navModal: {
        borderRadius: '20px',
        padding: '20px',

        '& h3': {
            fontSize: '15px',
            fontWeight: 600,
            color: '#333',
            margin: 0,
        },
    },
    tableContainer: {},
    table: {
        // for mobile view
        '@media (max-width: 768px)': {
            display: 'none',
        },
        borderCollapse: 'collapse',
        width: '85%',
        margin: '0 auto',
        '& th, & td': {
            border: '1px solid #ddd',
            padding: '12px 8px',
            textAlign: 'left',
            fontSize: '14px',
        },
        '& th': {
            backgroundColor: '#f8f9fa',
            fontWeight: 600,
            color: '#333',
        },
        '& td': {
            backgroundColor: '#fff',
        },
        // Remove alternating row colors - all rows should be white
    },
    modalSubtitle: {
        marginBottom: '20px',
        '& h3': {
            fontSize: '13px',
            fontWeight: 600,
            color: '#666',
            margin: 0,
        },
    },
    notesSection: {
        marginTop: '20px',
    },
    noteBox: {
        backgroundColor: '#f0f0f0',
        padding: '12px',
        width: '80%',
        margin: '0 auto',
        marginBottom: '15px',
        '& p': {
            margin: 0,
            fontSize: '12px',
            color: '#333',
        },
    },
    definition: {
        marginBottom: '15px',
        '& p': {
            margin: 0,
            fontSize: '14px',
            color: '#333',
        },
    },
    netBankingNote: {
        marginBottom: '15px',
        '& p': {
            margin: 0,
            fontSize: '14px',
            color: '#333',
        },
    },
    tDayBanks: {
        marginBottom: '15px',
        '& p': {
            margin: 0,
            fontSize: '14px',
            color: '#333',
        },
    },
    importantNote: {
        marginBottom: '40px',
        '& p': {
            margin: 0,
            fontSize: '14px',
            color: '#333',
            fontWeight: 500,
        },
    },
    modalActions: {
        textAlign: 'center',
        marginTop: '20px',
    },
    okButton: {
        backgroundColor: '#673AB7',
        color: 'white',
        border: 'none',
        padding: '10px 30px',
        borderRadius: '4px',
        width: '200px',
        fontSize: '14px',
        fontWeight: 400,
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: '#5E35B1',
        },
    },
}));

const NavDialog = ({
    showNavDialog,
    setShowNavDialog,
    handleInvest,
    handleApInvest,
    amc,
}: {
    showNavDialog: boolean;
    setShowNavDialog: (show: boolean) => void;
    handleInvest?: (options: any) => (callBackArgs: any) => void;
    handleApInvest?: (options: any) => void;
    amc: string;
}) => {
    const classes = useStyles();
    const dispatch = useDispatch();

    const [bankNames, setBankNames] = useState<string>('');

    useEffect(() => {
        if (!amc || bankNames) return;
        const callApi = async () => {
            try {
                const res: any = await dispatch(
                    getAllowedBankDetails({
                        amc,
                        reqId: '',
                    }),
                );
                setBankNames(res?.body?.data?.[0]?.bankName);
            } catch (err: any) {
                alert(err.message);
            }
        };
        callApi();
    }, [amc, showNavDialog]);

    const paymentModesData = [
        {
            slNo: 1,
            paymentMode: 'UPI',
            bankName: 'All Banks',
            cutOffTime: '2.45 PM',
            dayOfDebit: 'T',
            dayOfUnitAllotment: 'T',
        },
        {
            slNo: 2,
            paymentMode: 'Net Banking*',
            bankName: 'All Banks',
            cutOffTime: '2.45 PM',
            dayOfDebit: 'T',
            dayOfUnitAllotment: 'T/T+1',
        },
        {
            slNo: 3,
            paymentMode: 'NACH Mandate',
            bankName: 'All Banks',
            cutOffTime: '3.00 PM',
            dayOfDebit: 'T+1',
            dayOfUnitAllotment: 'T+2',
        },
    ];

    return (
        <Dialog
            fullWidth
            maxWidth={'md'}
            open={showNavDialog}
            style={{ width: '100%', margin: '0 auto' }}
        >
            <div className={classes.navModal}>
                <div className={classes.heading}>
                    <h3>
                        Payment modes and their implication on NAV
                        <span>
                            <a className="close" onClick={() => setShowNavDialog(false)}>
                                <img src="/images/close-black.svg" alt="" />
                            </a>
                        </span>
                    </h3>
                </div>
                <div className="content-outer">
                    <div className="content-inner">
                        <div className={classes.modalSubtitle}>
                            <h3>Lumpsum Transactions - Non-Liquid Schemes</h3>
                        </div>

                        <div className={classes.tableContainer}>
                            <Table className={classes.table}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Sl. No.</TableCell>
                                        <TableCell>Payment Mode</TableCell>
                                        <TableCell>Bank Name</TableCell>
                                        <TableCell>Cut off Time</TableCell>
                                        <TableCell>Day of Debit to Investor's account</TableCell>
                                        <TableCell>Day of Unit Allotment</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {paymentModesData.map((row) => (
                                        <TableRow key={row.slNo}>
                                            <TableCell>{row.slNo}.</TableCell>
                                            <TableCell>{row.paymentMode}</TableCell>
                                            <TableCell>{row.bankName}</TableCell>
                                            <TableCell>{row.cutOffTime}</TableCell>
                                            <TableCell>{row.dayOfDebit}</TableCell>
                                            <TableCell>{row.dayOfUnitAllotment}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </div>

                        {/* vertical table for mobile view */}
                        <div>
                            <Table className={classes.mobileTable}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Pay Mode</TableCell>
                                        <TableCell>Bank Name</TableCell>
                                        <TableCell>Cut off Time</TableCell>
                                        <TableCell>Day of Debit</TableCell>
                                        <TableCell>Day of Unit Allot</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {paymentModesData.map((row) => (
                                        <TableRow key={row.slNo}>
                                            <TableCell>{row.paymentMode}</TableCell>
                                            <TableCell>{row.bankName}</TableCell>
                                            <TableCell>{row.cutOffTime}</TableCell>
                                            <TableCell>{row.dayOfDebit}</TableCell>
                                            <TableCell>{row.dayOfUnitAllotment}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </div>

                        <div className={classes.noteBox}>
                            <p>
                                <span style={{ fontStyle: 'italic', fontWeight: 400 }}>
                                    #T day settlements are further subjected to AMC operations,
                                    please reach out to AMC/RTA for further details and support
                                </span>
                            </p>
                        </div>

                        <div className={classes.notesSection}>
                            <div className={classes.definition}>
                                <p>
                                    <strong>T</strong> = Transaction date based on cut-off time;{' '}
                                    <strong>T+1</strong> = Transaction date + 1 day;{' '}
                                    <strong>T+2</strong> = Transaction date + 2 day and so on.
                                </p>
                            </div>

                            <div className={classes.netBankingNote}>
                                <p>
                                    * While some major banks are technically enabled to provide real
                                    time credit, not all Payment Aggregator/ AMC may be integrated
                                    with all the banks. In such cases, the date of credit to MF
                                    account and unit allotment will happen on T + 1.
                                </p>
                            </div>

                            <div className={classes.tDayBanks}>
                                <p>
                                    <strong>T-day settlement banks for Net banking:</strong>{' '}
                                    {!!bankNames
                                        ? bankNames
                                        : 'YES, Kotak Mahindra, ICICI, Axis, HDFC, SBI, IDBI, IndusInd, IDFC First, BOI, UBI'}
                                </p>
                            </div>

                            <div className={classes.importantNote}>
                                <p>
                                    <strong>Important Note:</strong> Unit allotment will be subject
                                    to receipt of funds in the mutual fund account before the
                                    applicable cut-off time 3:00 PM.
                                </p>
                            </div>
                        </div>

                        <div className={classes.modalActions}>
                            <SubmitButton
                                onClick={() => {
                                    setShowNavDialog(false);
                                    if (handleInvest) {
                                        handleInvest({ later: false, nav: false })({});
                                    } else if (handleApInvest) {
                                        handleApInvest({ nav: false });
                                    }
                                }}
                                label="OK"
                                style={{
                                    backgroundColor: '#673AB7',
                                    width: '200px',
                                    fontSize: '14px',
                                    margin: '0 auto',
                                    color: 'white',
                                    border: 'none',
                                    padding: '10px 30px',
                                    borderRadius: '4px',
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </Dialog>
    );
};

export default NavDialog;
